import React, { useState, useEffect } from 'react';

export interface CountdownErrorMessageProps {
  message: string;
}

export const CountdownErrorMessage: React.FC<CountdownErrorMessageProps> = ({ message }) => {
  const [timeLeft, setTimeLeft] = useState<number | null>(null);

  useEffect(() => {
    // Reset or initialize state when message changes
    if (!message) {
      setTimeLeft(null);
      return;
    }

    const match = message.match(/(\d+)\s*秒後に再度お試しください/);
    if (match) {
      setTimeLeft(parseInt(match[1], 10));
    } else {
      setTimeLeft(null);
    }
  }, [message]);

  useEffect(() => {
    if (timeLeft === null || timeLeft <= 0) return;

    const timerId = setInterval(() => {
      setTimeLeft((prev) => (prev !== null && prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft]);

  if (timeLeft !== null) {
    const formattedMessage = message.replace(/\d+\s*秒/, `${timeLeft} 秒`);
    return <>{formattedMessage}</>;
  }

  return <>{message}</>;
};
